module.exports = __webpack_public_path__ + "b6f29abfbe487cfa06c7f0c6184503a4.svg";